import { useNavigate } from 'react-router-dom';
import { Shield, Sword, ArrowLeft } from 'lucide-react';

const MAP_BG = 'https://static.prod-images.emergentagent.com/jobs/0e7ec82b-be21-4167-ae09-299c58207254/images/a6ba1e67d75484410a2228b04473d4ffe1eb3c0f0f499b1bc11640bf23a93737.jpeg';

export default function AirCombatHomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-950 relative">
      {/* Map background */}
      <div
        className="absolute inset-0 opacity-40"
        style={{ backgroundImage: `url(${MAP_BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />

      <div className="relative z-10 w-full max-w-lg">
        {/* Title */}
        <div className="text-center mb-6">
          <h1 className="font-heading text-4xl sm:text-5xl font-black text-white drop-shadow-lg mb-1">
            India vs Pakistan
          </h1>
          <p className="font-body text-sm text-gray-400">Sky&apos;s Air Force Game &mdash; Delhi Air Base</p>
        </div>

        {/* Map image */}
        <div className="rounded-2xl overflow-hidden border-2 border-gray-700 shadow-2xl mb-6">
          <img src={MAP_BG} alt="India Pakistan Map" className="w-full h-48 sm:h-56 object-cover" data-testid="air-combat-map" />
          <div className="bg-gray-900 px-4 py-2 flex items-center justify-between">
            <span className="font-body text-xs text-green-400 font-bold flex items-center gap-1">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              Delhi Air Base — Ready
            </span>
            <span className="font-body text-xs text-gray-500">Arrow keys + Spacebar</span>
          </div>
        </div>

        {/* Two mode buttons */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <button
            data-testid="mode-defence"
            onClick={() => navigate('/air-combat/play?type=defence')}
            className="group bg-blue-600 hover:bg-blue-500 border-2 border-blue-400/30 rounded-2xl p-5 text-center transition-all shadow-lg"
          >
            <Shield className="w-10 h-10 text-white mx-auto mb-2 group-hover:scale-110 transition-transform" strokeWidth={2} />
            <p className="font-heading text-lg font-black text-white">Defence</p>
            <p className="font-body text-[11px] text-blue-200 mt-1">Enemy planes attack Delhi. Get in your jet and defend!</p>
          </button>

          <button
            data-testid="mode-attack"
            onClick={() => navigate('/air-combat/play?type=attack')}
            className="group bg-red-600 hover:bg-red-500 border-2 border-red-400/30 rounded-2xl p-5 text-center transition-all shadow-lg"
          >
            <Sword className="w-10 h-10 text-white mx-auto mb-2 group-hover:scale-110 transition-transform" strokeWidth={2} />
            <p className="font-heading text-lg font-black text-white">Attack</p>
            <p className="font-body text-[11px] text-red-200 mt-1">Fly from Delhi towards Pakistan and attack targets!</p>
          </button>
        </div>

        <div className="text-center">
          <button
            data-testid="air-combat-back"
            onClick={() => navigate('/')}
            className="text-gray-500 font-bold text-sm hover:text-gray-300 transition-colors inline-flex items-center gap-1"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Studio
          </button>
        </div>
      </div>
    </div>
  );
}
